<app-tb-picker
    class="w-full inline-flex"
    [itemTemplate]="item"
    [selectedItem]="selectedIcon === defaultStatusIcon ? null : selectedIcon"
    (selectItem)="selectIcon($event)"
    [name]="name()"
    [items]="pickerItems"
    [showClear]="set() === SetType.STATUS"
    [large]="true"
    titleKey="icon_title"
    [subtitle]="subtitle()"
>
    <div
        #triggerItem
        trigger
        [class]="name() ? 'name-icon-item' : 'cursor-pointer w-5 h-5 m-2 rounded-md'"
    >
        @if (name()) {
            <app-tb-icon
                [style.color]="iconColor() ?? defaultColor"
                [icon]="selectedIcon ?? defaultStatusIcon"
                [filled]="filled"
            ></app-tb-icon>
        } @else {
            <app-tb-icon
                color="text"
                [icon]="selectedIcon ?? defaultStatusIcon"
                [filled]="selectedIcon === defaultStatusIcon ? false : filled"
            ></app-tb-icon>
        }
    </div>
</app-tb-picker>
<ng-template #item let-item>
    <app-tb-button
        appearance="icon"
        class="hover:border-primaryLight border-2 cursor-pointer rounded-lg w-8 h-8"
        [class]="selectedIcon === item ? 'border-text hover:border-text' : 'border-transparent'"
    >
        <app-tb-icon color="text" [icon]="item" [filled]="filled"></app-tb-icon>
    </app-tb-button>
</ng-template>
